export interface ProjectContribution {
  name: string;
  commitCount: number;
}
